import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth, usePermissions, type Permission } from '@services/auth';

interface Props {
  readonly children: ReactNode;
  readonly permission?: Permission;
}

/**
 * Auth + permission gate at the route level. Unauthenticated → /login (stub).
 * Authenticated but missing permission → /dashboard with a flash (Phase 2 toast).
 *
 * Defence-in-depth only. Backend must enforce.
 */
export function ProtectedRoute({ children, permission }: Props): ReactNode {
  const { isAuthenticated, isLoading } = useAuth();
  const { has } = usePermissions();

  if (isLoading) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (permission && !has(permission)) return <Navigate to="/dashboard" replace />;
  return children;
}
